import type { colors } from '../theme/axiom-theme';

/**
 * ColorUtil - I turn a color into the form a stylesheet or the DOM needs it in.
 * ONLY concerned with the representation, never with which color is the right one.
 */
export const ColorUtil = {
  rgba2hex({ rgba }: { rgba: string }) {
    const match = rgba.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/
    );

    return match
      ? `#${match
          .slice(1, 4)
          .map(n => Number.parseInt(n, 10).toString(16).padStart(2, '0'))
          .join('')}${
          match[4] && Number.parseFloat(match[4]) < 1
            ? Math.round(Number.parseFloat(match[4]) * 255)
                .toString(16)
                .padStart(2, '0')
            : ''
        }`
      : undefined;
  },

  /*
    A color token as the class the stylesheet declares it under - `panelLightBlue` reads as
    `panel-light-blue`. A class rather than an inline style, so a scope that re-emits the sheet
    against its own tokens still reaches it.
  */
  tokenClass({
    color,
    prefix,
  }: {
    color?: keyof typeof colors;
    prefix: string;
  }) {
    return (
      color &&
      `${prefix}-${color.replaceAll(/([\da-z])([A-Z])/g, '$1-$2').toLowerCase()}`
    );
  },

  /*
    The same class, for the palettes that name their colors for display rather than as tokens -
    `light blue` reads as `light-blue`.
  */
  nameClass({ color, prefix }: { color: string; prefix: string }) {
    return `${prefix}-${color.replaceAll(' ', '-')}`;
  },
};
